<template lang="pug">
  i(:style="getIconStyles()" class="ui-svg-icon transition-colors")
</template>

<script>
export default {
  props: {
    name: { type: String, default: '' },
    url: { type: String, default: '' },
    size: { type: [Number, String], default: null },
    color: { type: String, default: null }
  },
  methods: {
    getIconStyles() {
      const url = this.url || require(`@/assets/icons/${this.name}.svg`)
      if (!url) {
        console.warn('Icon name or url is not set')
        return
      }

      let styles = `--icon-url: url(${url});`

      if (this.size) {
        styles += ` --icon-size: ${this.size}px;`
      }
      if (this.color) {
        styles += ` --icon-color: ${this.color};`
      }

      return styles
    }
  }
}
</script>

<style lang="sass" scoped>
.ui-svg-icon
  &::before
    width: var(--icon-size, 1.25rem)
    height: var(--icon-size, 1.25rem)
    display: block
    content: ''
    background: var(--icon-color, currentColor)
    -webkit-mask-size: contain
    mask-size: contain
    -webkit-mask: var(--icon-url) no-repeat center
    mask: var(--icon-url) no-repeat center
</style>
